const logout = (navigate) => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  navigate("/login");
};

export default {logout}
